import React, { useState } from "react";
import styled from "styled-components";
import { FaWhatsapp } from "react-icons/fa";
import video from "../assets/videos.mp4";

const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 100vh;
  }

  @media (max-width: 480px) {
    height: 100vh;
    width: 100%;
  }

  .video-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(31, 30, 30, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 50px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px;
      gap: 20px;
    }

    @media (max-width: 480px) {
      padding: 10px;
      gap: 15px;
    }
  }

  .intro-content {
    color: #fff;
    max-width: 50%;

    p {
      font-size: 1.5rem;
      margin-bottom: 20px;
    }

    .btn {
      padding: 10px 20px;
      font-size: 1.4rem;
      color: #fff;
      background-color: #f39c12;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background-color: #e67e22;
      }
    }

    @media (max-width: 768px) {
      max-width: 100%;
      text-align: center;

      p {
        font-size: 1rem;
      }

      .btn {
        font-size: 1.2rem;
        padding: 8px 16px;
      }
    }

    @media (max-width: 480px) {
      p {
        font-size: 1.3rem;
      }

      .btn {
        font-size: 1.2rem;
        padding: 6px 12px;
      }
    }
  }

  .contact-form {
    background: rgba(25, 25, 25, 0.8);
    padding: 20px;
    margin-top: 30px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
    animation: fadeInRight 1s ease;
    width: 35%;

    .contact-header {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 1.5rem;
      margin-bottom: 15px;

      .whatsapp-icon {
        color: #25d366;
        margin-left: 10px;
        font-size: 2.5rem;
      }
    }

    input,
    textarea {
      width: 100%;
      padding: 10px;
      margin-bottom: 15px;
      border: none;
      border-bottom: 2px solid rgba(255, 255, 255, 0.5);
      font-size: 1.4rem;
      background: transparent;
      color: #fff;
      transition: border-bottom-color 0.3s ease;

      &:hover {
        border-bottom-color: #f39c12;
      }

      &:focus {
        border-bottom-color: #e67e22;
        outline: none;
      }

      &::placeholder {
        color: rgba(255, 255, 255, 0.7);
        font-style: italic;
      }
    }

    button {
      width: 100%;
      padding: 10px;
      font-size: 1.4rem;
      color: #fff;
      background-color: #f39c12;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background-color: #e67e22;
      }
    }

    .error-message {
      color: red;
      font-size: 1.2rem;
      margin-top: 5px;
    }

    @media (max-width: 768px) {
      width: 90%;
      margin-top: 20px;

      input,
      textarea {
        font-size: 1rem;
      }

      button {
        font-size: 1rem;
        padding: 8px;
      }
    }

    @media (max-width: 480px) {
      input,
      textarea {
        font-size: 1.2rem;
        padding: 6px;
      }

      button {
        font-size: 1.2rem;
        padding: 6px;
      }
    }
  }

  .get-in-touch {
    position: fixed;
    bottom: 20px;
    right: 20px;
    color: white;
    font-size: 2rem;
    padding: 15px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    animation: bounce 1s infinite alternate;
    z-index: 1000;

    @media (max-width: 768px) {
      bottom: 15px;
      right: 15px;
      font-size: 1.8rem;
      padding: 12px;
    }

    @media (max-width: 480px) {
      bottom: 10px;
      right: 10px;
      font-size: 1.6rem;
      padding: 10px;
    }

    .whatsapp-icon {
      font-size: 2.5rem;
      transition: transform 0.3s ease;

      &:hover {
        transform: rotate(15deg);
      }
    }
  }

  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes bounce {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }
`;

const Heading = styled.h1`
  font-size: 5.2rem;

  .subheading {
    font-size: 1.3rem;
    display: block;
    margin-top: 10px;
    gap: 30px;
  }

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 2.5rem;
    padding: 5px;
  }
`;

export const Header = (props) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [phoneError, setPhoneError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    if (name === "phone" && phoneError) {
      setPhoneError("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const phonePattern = /^\d{10}$/;
    if (!phonePattern.test(formData.phone)) {
      setPhoneError("Please enter a valid 10-digit phone number.");
      setIsLoading(false);
      return;
    }

    const googleFormURL = "https://docs.google.com/forms/u/0/d/e/1FAIpQLSeti7tuvvDDsmUh95C1EAxc56pZ1CEY8jM3onWGEsUqAUyJxQ/formResponse";
    
    const formDataToSend = new FormData();
    formDataToSend.append("entry.1896703316", formData.name);
    formDataToSend.append("entry.519325375", formData.phone); 
    formDataToSend.append("entry.1383771125", formData.email);
    formDataToSend.append("entry.1065818106", formData.message);

    fetch(googleFormURL, {
      method: "POST",
      body: formDataToSend,
      mode: "no-cors"
    })
      .then(() => {
        alert("Message sent successfully!");
        setIsLoading(false);
        setFormData({ name: "", phone: "", email: "", message: "" });
      })
      .catch(() => {
        alert("An error occurred. Please try again.");
        setIsLoading(false);
      });
  };

  return (
    <HeaderContainer>
      <video autoPlay loop muted playsInline className="video-bg">
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="overlay">
        <div className="intro-content">
          <Heading>
            Tangled Up In Green
            <br />
            <span className="subheading">
              400 mtrs from Satellite Town Ring Road (STRR)
            </span>
          </Heading>

          <p>
            Plotted Development by <strong><span style={{ fontSize: "22px" }}>Total Environment.</span></strong>
          </p>
          <a href="#features" className="btn">
            Learn More
          </a>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-header">
            Contact Us
            <a
              href="https://wa.me/7090461000"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-icon"
            >
              <FaWhatsapp />
            </a>
          </div>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
          />
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Your Phone Number"
          />
          {phoneError && <div className="error-message">{phoneError}</div>}
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
          />
          <textarea
            rows="4"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
          ></textarea>
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
      <a
        href="https://wa.me/7090461000"
        target="_blank"
        rel="noopener noreferrer"
        className="get-in-touch"
      >
        <FaWhatsapp style={{ marginRight: '8px', fontSize: '6rem', color: "#41f305" }} />
      </a>
    </HeaderContainer>
  );
};
